import styled from 'styled-components';

const LogoutBodyContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default LogoutBodyContainer;
